import React from 'react'
import PropTypes from 'prop-types'

class TableContainer extends React.PureComponent {
  _onPaginationChange = (pagination, filters, sorter) => {
    console.log('_onPaginationChange ->', pagination, filters, sorter)
    this.props.onPaginationChange(pagination, filters, sorter)
  }

  _onRowClick = (record, index, event) => {
    const { onRowClick } = this.props
    typeof onRowClick === 'function' && onRowClick(record, index, event)
  }

  _onRow = (record, rowIndex) => {
    return {
      onClick: () => this._onRowClick(record, rowIndex), // click row
      onDoubleClick: (event) => {}, // double click row
      onContextMenu: (event) => {}, // right button click row
      onMouseEnter: (event) => {}, // mouse enter row
      onMouseLeave: (event) => {} // mouse leave row
    }
  }

  render () {
    const { style } = this.props
    return (
      <div className='bo-table-container' style={style || {}}>
        {this.props.children({ onRow: this._onRow, onPaginationChange: this._onPaginationChange })}
      </div>
    )
  }
}

TableContainer.propTypes = {
  children: PropTypes.any,
  onRowClick: PropTypes.func,
  onPaginationChange: PropTypes.func
}

TableContainer.defaultProps = {
  onPaginationChange: () => null
}

export default TableContainer
